import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { updateAttractionImage } from '~/services/AttractionsService';

import { attractionQueryKeys } from './attractionQueryKeys';

/**
 * Sets the hero image for an attraction and invalidates cache.
 */
export function useUpdateAttractionImage() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ attractionId, imageId }: { attractionId: string; imageId: string }) => {
      return await updateAttractionImage(attractionId, imageId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.all });
      enqueueSnackbar('Hero image updated successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error updating image: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
